export const USER_REQUEST = 'USER_REQUEST'
export const USER_CPTY_REQUEST = 'USER_CPTY_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_FREE_DATA = 'USER_FREE_DATA'

export const USER_CONT_ADD = 'USER_CONT_ADD'
export const USER_CONT_UPDATE = 'USER_CONT_UPDATE'
export const USER_CONT_DELETE = 'USER_CONT_DELETE'
export const USER_CONT_MAIN = 'USER_CONT_MAIN'

export const USER_GET_ACCEPTORS = 'USER_GET_ACCEPTORS'
export const USER_CLEAR_ACCEPTORS = 'USER_CLEAR_ACCEPTORS'
export const USER_SET_CURRENT_ACCEPTOR = 'USER_SET_CURRENT_ACCEPTOR'
export const USER_SEND_LIKE = 'USER_SEND_LIKE'
export const USER_GET_MARK = 'USER_GET_MARK'

export const USER_SEND_ANKETA = 'USER_SEND_ANKETA'
export const USER_SEND_FEEDBACK = 'USER_SEND_FEEDBACK'

export const USER_GET_OKPD = 'USER_GET_OKPD'
export const USER_GET_USERS = 'USER_GET_USERS'
